var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.7531C24 14.6602 21.7947 14.7592 21.7947 14.7592C21.7947 14.7592 23.4363 14.5498 23.4363 12.8479C23.4363 11.5921 22.3637 10.9038 20.7385 10.9038H14.7956C14.7956 10.9038 15.7752 7.84693 15.7752 5.39595C15.7752 1.90399 14.1061 1.1493 13.1484 1.0061C12.8091 0.956527 12.4972 1.21539 12.4699 1.55688C12.2783 4.01337 10.9158 7.53284 8.66119 9.79656C6.22603 12.2475 2.09446 13.1012 2.09446 13.1012C2.09446 13.1012 1 15.073 1 19.1598C1 23.2466 2.64168 24.1169 2.64168 24.1169C2.64168 24.1169 4.24507 24.1336 5.87034 24.1336C8.3055 24.1336 9.79395 25.7692 13.039 25.7692H17.9641C21.4882 25.7692 22.3419 25.268 22.3419 23.8635C22.3419 22.5912 21.2474 22.4645 21.2474 22.4645C21.2474 22.4645 23.4363 22.5747 23.4363 20.5589C23.4363 18.7964 21.7947 18.6091 21.7947 18.6091C21.7947 18.6091 24 18.7689 24 16.7475V16.7531Z",
    stroke: "#322D60",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/Thumb.75a40f500a71a1391be8c79628a71c06.svg";
export { ForwardRef as ReactComponent };